var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApple = function SvgApple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{clip-path:url(#SVGID_00000129909699251482066220000014297901075820968877_);}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042705082681316709170000018097729694369660812_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.2,17.6c-0.3,0.7-0.7,1.3-1.1,1.9c-0.6,0.8-1,1.4-1.4,1.7c-0.6,0.5-1.1,0.8-1.8,0.8c-0.5,0-1-0.1-1.6-0.4 c-0.6-0.3-1.2-0.4-1.8-0.4c-0.6,0-1.2,0.1-1.8,0.4C10,21.8,9.5,22,9.1,22c-0.6,0-1.2-0.2-1.8-0.8c-0.4-0.3-0.9-0.9-1.4-1.7 c-0.6-0.9-1.1-1.9-1.5-3c-0.4-1.2-0.6-2.5-0.6-3.6c0-1.3,0.3-2.5,0.9-3.5C5,8.5,5.6,7.9,6.4,7.5C7.1,7,7.9,6.8,8.8,6.8 c0.5,0,1.1,0.1,1.9,0.4c0.8,0.3,1.3,0.4,1.5,0.4c0.2,0,0.7-0.2,1.7-0.5c0.9-0.3,1.7-0.5,2.3-0.4c1.7,0.1,2.9,0.8,3.8,2 c-1.5,0.9-2.2,2.2-2.2,3.8c0,1.3,0.5,2.3,1.4,3.2c0.4,0.4,0.9,0.7,1.4,0.9C20.4,17,20.3,17.3,20.2,17.6z M16.3,2.4 c0,1-0.4,1.9-1.1,2.8c-0.9,1-1.9,1.6-3.1,1.5c0-0.1,0-0.2,0-0.4c0-1,0.4-2,1.2-2.8c0.4-0.4,0.8-0.8,1.4-1.1 C15.2,2.2,15.8,2,16.3,2C16.3,2.1,16.3,2.3,16.3,2.4L16.3,2.4z"
  })))));
};
export default SvgApple;